/**
 * @generated SignedSource<<cb62d05fb400e37a7f1b64454009a994>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "GoogleTokenResponse",
    "kind": "LinkedField",
    "name": "googleToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tokenType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "callback2ComponentsGoogleTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "callback2ComponentsGoogleTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "51821b2b9b7bb56cfacc1b0481b90cfc",
    "id": null,
    "metadata": {},
    "name": "callback2ComponentsGoogleTokenMutation",
    "operationKind": "mutation",
    "text": "mutation callback2ComponentsGoogleTokenMutation(\n  $request: GoogleTokenRequestInput\n) {\n  googleToken(request: $request) {\n    tokenType\n    accessToken\n    refreshToken\n  }\n}\n"
  }
};
})();

node.hash = "e53bec658b0c6db600cc271eca4e3b52";

module.exports = node;
